var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconEclipse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9333 12.7999H17.0666V10.6666H14.9333V12.7999ZM15.9999 24.5333C11.2959 24.5333 7.46659 20.7039 7.46659 15.9999C7.46659 11.2959 11.2959 7.46659 15.9999 7.46659C20.7039 7.46659 24.5333 11.2959 24.5333 15.9999C24.5333 20.7039 20.7039 24.5333 15.9999 24.5333ZM15.9999 5.33325C10.1119 5.33325 5.33325 10.1119 5.33325 15.9999C5.33325 21.8879 10.1119 26.6666 15.9999 26.6666C21.8879 26.6666 26.6666 21.8879 26.6666 15.9999C26.6666 10.1119 21.8879 5.33325 15.9999 5.33325ZM14.9333 21.3333H17.0666V14.9333H14.9333V21.3333Z",
    fill: "#002CB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconEclipse);
export default __webpack_public_path__ + "static/media/Info_Icon_Eclipse.d25dd0814f6dc426f666a19d3caabb36.svg";
export { ForwardRef as ReactComponent };